// Dollar Prices Getters

export const getDollarPricesList = state => {
  return state.dollarPricesList
}

export const getLastDollarPrice = state => {
  return state.lastDollarPrice
}

export const getDollarPriceInfo = state => {
  return state.dollarPriceInfo
}
